<template>
  <div class="layout-topbar">
    <div class="topbar-wrapper">
      <!-- Logo -->
      <div class="topbar-logo">
        <img
          v-if="empresa.logo"
          :src="'data:image/png;base64, ' + empresa.logo"
          width="100"
          height="60"
          alt="Logo.jpg"
          class="logo-img"
        />
      </div>

      <!-- Menu Toggle Button -->
      <button
        class="menu-toggle-btn"
        @click="onMenuToggle"
        v-tooltip.bottom="'Menú'"
      >
        <i class="pi pi-bars"></i>
      </button>

      <!-- Centro - Sucursal (oculto en móviles) -->
      <div class="centro-topbar">
        <div class="branch-display">
          <i class="pi pi-building"></i>
          <div class="branch-info">
            <span class="branch-label">Sucursal</span>
            <span class="branch-name">{{ empresa.nombre || "Central" }}</span>
          </div>
        </div>
      </div>

      <!-- Derecha - Usuario y Acciones -->
      <div class="right-topbar">
        <div class="topbar-right">
          <div class="user-section">
            <div class="user-avatar">
              <i class="pi pi-user"></i>
            </div>
            <div class="user-details">
              <span class="user-label">Usuario</span>
              <span class="user-name">{{ user.name }}</span>
            </div>
          </div>

          <div class="topbar-divider-vertical"></div>

          <div class="topbar-actions">
            <Button
              class="action-btn profile-btn"
              @click="irAPerfil"
              v-tooltip.bottom="'Mi Perfil'"
              icon="pi pi-user-edit"
            />

            <Button
              class="action-btn logout-btn"
              @click="openNuevo"
              v-tooltip.bottom="'Cerrar Sesión'"
              icon="pi pi-sign-out"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Dialogo de Cerrar Sesión -->
  <Dialog
    v-model:visible="salirDialog"
    :style="{ width: '420px' }"
    header="Cerrar Sesión"
    :modal="true"
    class="p-fluid logout-dialog"
    :showHeader="true"
    :closable="true"
  >
    <div class="dialog-content">
      <div class="dialog-icon">
        <i
          class="pi pi-exclamation-circle"
          style="font-size: 5rem; color: #f39c12"
        ></i>
      </div>
      <p class="dialog-message">
        ¿Estás seguro de que deseas cerrar tu sesión?
      </p>
    </div>

    <template #footer>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        @click="ocultarDialog"
      />
      <Button
        label="Cerrar Sesión"
        icon="pi pi-sign-out"
        class="p-button-danger"
        @click="cerrarSession()"
      />
    </template>
  </Dialog>
</template>

<script>
import { useAuth } from "@/stores";
import EmpresaService from "@/service/EmpresaService";

export default {
  emits: ["menu-toggle"],
  data() {
    return {
      empresa: {},
      user: {},
      salirDialog: false,
    };
  },
  auth: null,
  empresaService: null,
  beforeCreate() {
    this.empresaService = new EmpresaService();
    this.empresaService.getFirstEmpresa().then((response) => {
      this.empresa = response.data;
    });
  },
  created() {
    this.auth = useAuth();
  },
  mounted() {
    this.user = { ...this.auth.user };
  },
  methods: {
    irAPerfil() {
      this.$router.push("/usuario-detalle");
    },
    openNuevo() {
      this.salirDialog = true;
    },
    ocultarDialog() {
      this.salirDialog = false;
    },
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    cerrarSession() {
      return this.auth.userLogout();
    },
  },
};
</script>

<style scoped lang="scss">
.topbar-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 2rem;
  height: 80px;
  gap: 1.5rem;
  width: 100%;
  box-sizing: border-box;
}

/* Logo */
.topbar-logo {
  display: flex;
  align-items: center;
  min-width: fit-content;
  flex-shrink: 0;
}

.logo-img {
  height: 60px;
  width: auto;
  object-fit: contain;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }
}

/* Menu Toggle Button */
.menu-toggle-btn {
  background: none;
  border: none;
  color: #495057;
  font-size: 1.3rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  min-width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:hover {
    background: rgba(52, 152, 219, 0.1);
    color: #3498db;
  }
}

/* Centro - Sucursal */
.centro-topbar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.branch-display {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  i {
    font-size: 1.3rem;
    color: #3498db;
  }
}

.branch-info {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.branch-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #7f8c8d;
  font-weight: 600;
}

.branch-name {
  font-size: 1rem;
  color: #2c3e50;
  font-weight: 600;
  letter-spacing: 0.3px;
}

/* Derecha - Usuario y Acciones */
.right-topbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: fit-content;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  min-width: fit-content;
}

.topbar-divider-vertical {
  width: 1px;
  height: 40px;
  background: linear-gradient(
    180deg,
    transparent 0%,
    #e9ecef 50%,
    transparent 100%
  );
}

/* User Section */
.user-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.user-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3498db, #2c3e50);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.2);
  flex-shrink: 0;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: fit-content;
}

.user-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #7f8c8d;
  font-weight: 600;
}

.user-name {
  font-size: 0.95rem;
  color: #2c3e50;
  font-weight: 600;
  letter-spacing: 0.2px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Actions */
.topbar-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.action-btn {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.1rem;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
}

.profile-btn {
  color: #3498db;
  background: rgba(52, 152, 219, 0.1);
  border: 1px solid rgba(52, 152, 219, 0.2);

  &:hover {
    color: #002236;
    background: rgba(52, 152, 219, 0.2);
    border-color: rgba(52, 152, 219, 0.4);
    box-shadow: 0 4px 12px rgba(52, 152, 219, 0.15);
  }
}

.logout-btn {
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.2);

  &:hover {
    color: #922b21;
    background: rgba(231, 76, 60, 0.2);
    border-color: rgba(231, 76, 60, 0.4);
    box-shadow: 0 4px 12px rgba(231, 76, 60, 0.15);
  }
}

/* Logout Dialog */
.logout-dialog {
  :deep(.p-dialog-header) {
    background: linear-gradient(135deg, #3498db, #2c3e50);
    color: white;
    border: none;
    padding: 1.25rem;

    .p-dialog-title {
      font-weight: 600;
      font-size: 1.1rem;
      letter-spacing: 0.3px;
    }

    .p-dialog-header-close {
      color: white;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
  }

  :deep(.p-dialog-content) {
    padding: 2rem;
  }

  :deep(.p-dialog-footer) {
    border-top: 1px solid #e9ecef;
    padding: 1.5rem;
    gap: 0.75rem;
  }
}

.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.dialog-icon {
  font-size: 5rem;
  color: #f39c12;
  animation: pulse-icon 2s infinite;
}

@keyframes pulse-icon {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

.dialog-message {
  font-size: 1.5rem;
  color: #2c3e50;
  margin: 0;
  line-height: 1.6;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 1200px) {
  .topbar-wrapper {
    padding: 0.75rem 1rem;
    gap: 1rem;
  }

  .user-name {
    max-width: 120px;
  }
}

@media (max-width: 991px) {
  .topbar-wrapper {
    padding: 0.75rem 1rem;
    gap: 1rem;
  }

  .centro-topbar {
    flex: 0.8;
  }

  .branch-name {
    font-size: 0.9rem;
  }
}

/* Tablets */
@media (max-width: 768px) {
  .topbar-wrapper {
    padding: 0.75rem 0.75rem;
    gap: 0.75rem;
    height: 70px;
  }

  .topbar-logo {
    min-width: 80px;
  }

  .logo-img {
    height: 50px;
  }

  .menu-toggle-btn {
    min-width: 40px;
    height: 40px;
    font-size: 1.2rem;
  }

  .centro-topbar {
    display: none; /* Ocultamos la sucursal en tablets */
  }

  .user-name {
    max-width: 100px;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }

  .action-btn {
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }
}

/* Teléfonos */
@media (max-width: 576px) {
  .topbar-wrapper {
    padding: 0.5rem 0.75rem;
    height: 65px;
    gap: 0.5rem;
  }

  .topbar-logo {
    min-width: 60px;
  }

  .logo-img {
    height: 45px;
  }

  .menu-toggle-btn {
    min-width: 36px;
    height: 36px;
    font-size: 1.1rem;
  }

  .centro-topbar {
    display: none; /* Ocultamos completamente la sucursal en móviles */
  }

  .topbar-right {
    gap: 0.75rem;
  }

  .user-section {
    gap: 0.5rem;
  }

  .user-details {
    display: none; /* Ocultamos detalles del usuario en móviles */
  }

  .user-avatar {
    width: 36px;
    height: 36px;
    font-size: 0.9rem;
  }

  .topbar-divider-vertical {
    display: none; /* Ocultamos el divisor en móviles */
  }

  .topbar-actions {
    gap: 0.25rem;
  }

  .action-btn {
    width: 34px;
    height: 34px;
    font-size: 0.9rem;
  }
}

/* Teléfonos pequeños */
@media (max-width: 375px) {
  .topbar-wrapper {
    padding: 0.5rem;
    gap: 0.25rem;
  }

  .topbar-logo {
    min-width: 50px;
  }

  .logo-img {
    height: 40px;
  }

  .menu-toggle-btn {
    min-width: 32px;
    height: 32px;
    font-size: 1rem;
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    font-size: 0.8rem;
  }

  .action-btn {
    width: 32px;
    height: 32px;
    font-size: 0.85rem;
  }
}
</style>
